import { useMemo } from "react";
import { ImageLite, Paragraph } from "shared/components";
import { useTabsState } from "shared/components/Tabs/Tabs.hooks";

import styles from "./Items.module.scss";

export const Items = ({ items }) => {
  const { activeTab } = useTabsState();

  const filteredItems = useMemo(() => {
    return items.filter(({ title }) => title === activeTab);
  }, [activeTab, items]);
  if (filteredItems.length < 1) {
    return null;
  }

  const [item] = filteredItems;
  return (
    <div className={styles.wrapper}>
      <Paragraph className={styles.description} color="grey">
        {item.description}
      </Paragraph>
      <ImageLite image={item.image} className={styles.image} />
    </div>
  );
};
